import React from "react";
import AppIcons from "../../utils/AppIcons";
import TextureFileType from "../../model/enums/TextureFileType";
import FormDropDown from "./FormDropDown";
import { idText } from "typescript";

interface IFormUploadTextureFileProps {
  label: string;
  identifier: string;
  type: TextureFileType | undefined;
  warning_message?: string | undefined;
  onChange: (fileName: string, newMeaning: TextureFileType) => void;
}

function FormUploadTextureFile({
  identifier,
  label = "",
  type = TextureFileType.OTHER,
  warning_message = "",
  onChange,
}: IFormUploadTextureFileProps) {
  const options = Object.entries(TextureFileType).map(([key, value]) => ({
    label: key.replace(/_/g, " "),
    value: value.toString(),
  }));
  options.splice(0, 0, {
    value: "",
    label: "-- please select file meaning --",
  });

  const onMeaningChange = (id: string, value: string) => {
    onChange(identifier, value as TextureFileType);
  };

  return (
    <>
      <div className="form-upload-texture-file">
        {AppIcons.ARROW_RIGHT}
        {label && <label className="form-label">{label}</label>}
        <div className="flex-grow"></div>
        <FormDropDown
          label="File meaning "
          id={label + "_type"}
          value={type ?? TextureFileType.NOT_SET}
          required={true}
          options={options}
          onChange={onMeaningChange}
        />
      </div>
      {warning_message && (
        <div className="form-warning" style={{ marginTop: "0px" }}>
          {warning_message}
        </div>
      )}
    </>
  );
}

export default FormUploadTextureFile;
